module.exports = __webpack_public_path__ + "img/PayU.97dca6c9.svg";